angular.module('unergie.main')
.controller('refBeneficiaryCtrl', ($scope, $state, $uibModal, AlertManager, DataAccessRefTaxBeneficiary, CommonRegex,
    TableGeneratorService, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.beneficiaries = {
        refreshing: false,
        show: {},
        counts: [10, 25, 50, 100],
        columns: {
            siren: { label: 'Siren', mode: 'search_operator' },
            label: { label: 'Nom', mode: 'search_wildcard' },
            iban: { label: 'Iban', mode: 'search_wildcard' },
            bic: { label: 'BIC', mode: 'search_wildcard' },
            email_beneficiary: { label: 'Email bénéficiaire', mode: 'search_wildcard' },
            email: { label: 'Email comptable', mode: 'search_wildcard' },
            phone: { label: 'Téléphone', mode: 'search_wildcard' },
            beneficiary_type: { label: 'Type bénéficiaire', mode: 'search_wildcard' },
            year: { label: 'Année', mode: 'search_operator' },
        },
    }


    const activate = () => {
        TableGeneratorService.getTable($scope.beneficiaries, 'ref-tax-beneficiary', '', null, { orderBy: '-year,label' })
    }

    $scope.activate = activate
    activate()

    const taxBeneficiaryTemplate = {
        siren: '',
        label: '',
        iban: '',
        bic: '',
        email: '',
        phone: '',
        beneficiary_type: '',
    }
    $scope.taxBeneficiaryFields = {
        siren: {
            label: 'Siren',
            required: true,
            type: 'text',
        },
        label: {
            label: 'Nom',
            required: true,
            type: 'text',
        },
        iban: {
            label: 'IBAN',
            required: true,
            type: 'iban',
        },
        bic: {
            label: 'BIC',
            required: true,
            type: 'text',
            pattern: CommonRegex.bic,
        },
        email_beneficiary: {
            label: 'Email bénéficiaire',
            type: 'email',
        },
        email: {
            label: 'Email comptable',
            required: true,
            type: 'email',
        },
        phone: {
            label: 'Téléphone',
            required: true,
            type: 'text',
        },
        beneficiary_type: {
            label: 'Type bénéficiaire',
            required: true,
            type: 'text',
        },
        year: {
            label: 'Année',
            required: true,
            type: 'text',
        },
    }

    $scope.updateTaxBeneficiaryFields = angular.copy($scope.taxBeneficiaryFields)

    const resetTaxBeneficiaryPayload = () => {
        $scope.taxBeneficiaryPayload = angular.copy(taxBeneficiaryTemplate)
    }

    resetTaxBeneficiaryPayload()

    $scope.addTaxBeneficiary = () =>
        DataAccessRefTaxBeneficiary.addTaxBeneficiary($scope.taxBeneficiaryPayload).$promise.then(() => {
            resetTaxBeneficiaryPayload()
            return activate()
        }).catch(ErrorCatcher)


    $scope.updateTaxBeneficiary = function (taxBeneficiary) {
        const taxBeneficiaryPayload = angular.copy(taxBeneficiary)
        delete taxBeneficiaryPayload.id
        return DataAccessRefTaxBeneficiary.updateTaxBeneficiary({ id: taxBeneficiary.id }, taxBeneficiaryPayload).$promise.then(() => {
            AlertManager.success('Bénéficiaire de tax modifiée')
            return activate() }).catch(ErrorCatcher)
    }
})
